import React from "react";
import ReactDOM from "react-dom";
import { composeWithDevTools } from "redux-devtools-extension";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import rootSaga from "store/rootSaga";
import createSagaMiddleware from "redux-saga";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import "index.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "App.scss";
import App from "App";

import rootReducer from "store/combineReducers";
import getItemFromLocalStorage from "utils/getItemFromLocalStorage";
import { authenticatedUser } from "store/actions/auth.actions";
import { initializeClarity } from "utils/clarity";

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootSaga);

const user = getItemFromLocalStorage("user");
if (user) {
  store.dispatch(authenticatedUser(user));
}

initializeClarity();

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <Router>
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </Router>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
